import React, { useEffect, useState } from "react";
import Paper from "Components/UI/Paper";
import { createLogInvoice } from "API/swesum";
import { Skeleton, Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";

import ClientAccountsTableContainer from "Components/Account/ClientAccountsTableContainer";
import EndcustomerAccountsTableContainer from "Components/Account/EndcustomerAccountTableContainer";
import Logs from "Components/Workflows/Logs/Logs";
import EndCustomerPrintedTable from "Pages/AdminInterface/endcustomerprinted/components/EndCustomerPrintedTable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function InvoiceWorkflows({
  invoiceID,
  clientAccounts,
  endcustomerAccounts,
  fetchAccounts,
  payedInvoices,
  printedInvoices,
  fetchPrintedInvoices,
  logs,
  users,
  selectedLogs,
  resetSelectedLogs,
  loading,
}) {
  const [tabIndex, setTabindex] = useState(0);
  const [tableKey, setTableKey] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  useEffect(() => {
    if (selectedLogs) {
      resetSelectedLogs();
      setTabindex(5);
    }
  }, [selectedLogs]);

  return (
    <>
      <Paper>
        <Tabs
          value={tabIndex}
          onChange={handleTabSwitch}
          sx={{ marginBottom: "2rem" }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Fakturahändelser" />
          <Tab label="Loggar" />
          <Tab label="Fakturautskrift" />
          <Tab label="Klientkonto" />
        </Tabs>
        {loading ? (
          <Skeleton variant="rectangular" maxWidth height={200} />
        ) : (
          <>
            <TabPanel value={tabIndex} index={0} id="tabPanel0">
              <EndcustomerAccountsTableContainer
                key={tableKey}
                accounts={endcustomerAccounts}
                fetchAccounts={fetchAccounts}
                onRegretSuccess={() => { if (fetchAccounts) { fetchAccounts(); setTableKey((k) => k + 1); } }}
              />    
            </TabPanel>
            <TabPanel value={tabIndex} index={1} id="tabelPanel0">
              <Logs
                logs={logs}
                users={users}
                entityID={invoiceID}
                call={createLogInvoice}
                checkbox={true}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={2} id="tabelPanel0">
              <EndCustomerPrintedTable
                printedInvoices={printedInvoices}
                fetchPrintedInvoices={fetchPrintedInvoices}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={3} id="tabPanel0">
              <ClientAccountsTableContainer accounts={clientAccounts} />
            </TabPanel>
          </>
        )}
      </Paper>
    </>
  );
}
